<template>
    <div v-loading="loading">
      <!-- 搜索表单 -->
      <div class="searchForm">
        <el-form
          size="small"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-form-item label="选择时间">
            <el-date-picker
              v-model="datePicker"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="会员信息">
            <el-input
              v-model="searchForm.search"
              placeholder="真实姓名|手机号|身份证"
            ></el-input>
          </el-form-item>
          <el-form-item label="订单号"
            ><el-input
              size="small"
              v-model="searchForm.order_no"
              placeholder="请输入订单号"
            ></el-input
          ></el-form-item>
          <el-form-item label="操作员"
            ><el-input
              size="small"
              v-model="searchForm.remarks_operation"
              placeholder="请输入内容"
            ></el-input
          ></el-form-item>
          <el-form-item
            ><el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="getData"
              >查询</el-button
            ></el-form-item
          >
        </el-form>
      </div>
      <!-- 表格数据 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="id" label="id"> </el-table-column>
        <el-table-column prop="name" label="名称"> </el-table-column>
        <el-table-column prop="address" label="联系人"> </el-table-column>
        <el-table-column prop="city" label="联系电话"> </el-table-column>
        <el-table-column prop="date" label="加入时间"> </el-table-column>
        <el-table-column prop="province" label="推广订单"> </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button @click="restore(scope.row)" type="text" size="small">禁用</el-button>
            <el-button @click="restore(scope.row)" type="text" size="small">生成二维码链接</el-button>
            <el-button @click="restore(scope.row)" type="text" size="small">生成推广二维码</el-button>
            <el-button @click="restore(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </template>
  
  <script>
  import { formatDate } from "@/utils/DateTime.js";
  export default {
    data() {
      let endDate = new Date();
      let startDate = new Date();
      startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 1);
      return {
        loading: true,
        //时间
        pickerOptions: {
          shortcuts: [
            {
              text: "昨天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一年",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        datePicker: [
          formatDate(startDate, "yyyy-MM-dd 00:00:00"),
          formatDate(endDate, "yyyy-MM-dd 23:59:59"),
        ],
        // 搜索框
        searchForm: {
          search: "",
          order_no: "",
          remarks_operation: "",
        },
        //   表格数据
        tableData: [
          {
            id:1,
            date: "2023-07-02",
            name: "王小虎",
            province: "小V",
            city: "黑户",
            address: "2023092510199529",
            zip: 200333,
          },
          {
            id:2,
            date: "2023-08-21",
            name: "张辉",
            province: "小V",
            city: "租了50多台",
            address: "2023092510199511",
            zip: 200333,
          },
          {
            id:3,
            date: "2023-09-17",
            name: "谢烨",
            province: "小V",
            city: "老赖",
            address: "2023092510199505",
            zip: 200333,
          },
        ],
      };
    },
    methods: {
      // 获取数据
      getData() {
        console.log(this.datePicker, this.searchForm);
      },
      // 恢复白名单
      restore(row) {
        console.log(row);
      },
    },
    mounted() {
      this.loading = false;
    },
  };
  </script>
  
  <style lang="scss">
  .searchForm {
    display: flex;
  }
  </style>


// WEBPACK FOOTER //
// src/views/agent/agent/bill.vue